// NGRX
import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { AgreementTemplate } from '../_models/agreement-template.model';

export enum AgreementTemplateActionTypes {
  AllAgreementTemplatesRequested = '[AgreementTemplates Home Page] All AgreementTemplates Requested',
  AllAgreementTemplatesLoaded = '[AgreementTemplates API] All AgreementTemplates Loaded',
  AgreementTemplateOnServerCreated = '[Edit AgreementTemplate Dialog] AgreementTemplate On Server Created',
  AgreementTemplateCreated = '[Edit AgreementTemplates Dialog] AgreementTemplates Created',
  AgreementTemplateOnServerUpdated = '[Edit AgreementTemplate Dialog] AgreementTemplate On Server Updated',
  AgreementTemplateUpdated = '[Edit AgreementTemplate Dialog] AgreementTemplate Updated',
  AgreementTemplateOnServerDeleted = '[AgreementTemplates List Page] AgreementTemplate On Server Deleted',
  AgreementTemplateOnServerActivated = '[AgreementTemplates List Page] AgreementTemplate On Server Activated',
  AgreementTemplateDeleted = '[AgreementTemplates List Page] AgreementTemplate Deleted',
  AgreementTemplateActivated = '[AgreementTemplates List Page] AgreementTemplate Activated',
  AgreementTemplatesOnServerDeleted = '[AgreementTemplates List Page] AgreementTemplates On Server Deleted',
  AgreementTemplatesDeleted = '[AgreementTemplates List Page] AgreementTemplates Deleted',
  AgreementTemplatesPageRequested = '[AgreementTemplates List Page] AgreementTemplates Page Requested',
  AgreementTemplatesPageLoaded = '[AgreementTemplates API] AgreementTemplates Page Loaded',
  AgreementTemplatesPageCancelled = '[AgreementTemplates API] AgreementTemplates Page Cancelled',
  AgreementTemplatesPageToggleLoading = '[AgreementTemplates page] AgreementTemplates Page Toggle Loading',
  AgreementTemplatesActionToggleLoading = '[AgreementTemplates] AgreementTemplates Action Toggle Loading',
  ThrowAgreementTemplateError = '[AgreementTemplates] Throw AgreementTemplate Error',
  FireAgreementTemplateSuccess = '[AgreementTemplates] Fire Success',
}

export class AgreementTemplateOnServerCreated implements Action {
  readonly type = AgreementTemplateActionTypes.AgreementTemplateOnServerCreated;
  constructor(public payload: { agreementTemplate: AgreementTemplate; officeId: number }) {}
}

export class AgreementTemplateCreated implements Action {
  readonly type = AgreementTemplateActionTypes.AgreementTemplateCreated;
  constructor(public payload: { agreementTemplate: AgreementTemplate }) {}
}

export class AgreementTemplateOnServerUpdated implements Action {
  readonly type = AgreementTemplateActionTypes.AgreementTemplateOnServerUpdated;
  constructor(
    public payload: {
      partialagreementTemplate: Update<AgreementTemplate>;
      agreementTemplate: AgreementTemplate;
    },
  ) {}
}

export class AgreementTemplateUpdated implements Action {
  readonly type = AgreementTemplateActionTypes.AgreementTemplateUpdated;
  constructor(
    public payload: {
      partialagreementTemplate: Update<AgreementTemplate>;
      agreementTemplate: AgreementTemplate;
    },
  ) {}
}

export class AgreementTemplateOnServerDeleted implements Action {
  readonly type = AgreementTemplateActionTypes.AgreementTemplateOnServerDeleted;
  constructor(public payload: { id: number; office_id: number }) {}
}

export class AgreementTemplateOnServerActivated implements Action {
  readonly type = AgreementTemplateActionTypes.AgreementTemplateOnServerActivated;
  constructor(public payload: { id: number }) {}
}

export class AgreementTemplateDeleted implements Action {
  readonly type = AgreementTemplateActionTypes.AgreementTemplateDeleted;
  constructor(public payload: { id: number }) {}
}

export class AgreementTemplateActivated implements Action {
  readonly type = AgreementTemplateActionTypes.AgreementTemplateActivated;
  constructor(public payload: { id: number }) {}
}

export class AgreementTemplatesOnServerDeleted implements Action {
  readonly type = AgreementTemplateActionTypes.AgreementTemplatesOnServerDeleted;
  constructor(public payload: { ids: number[] }) {}
}

export class AgreementTemplatesDeleted implements Action {
  readonly type = AgreementTemplateActionTypes.AgreementTemplatesDeleted;
  constructor(public payload: { ids: number[] }) {}
}

export class AgreementTemplatesPageRequested implements Action {
  readonly type = AgreementTemplateActionTypes.AgreementTemplatesPageRequested;
  constructor(public payload: { page: QueryParamsModel }) {}
}

export class AgreementTemplatesPageLoaded implements Action {
  readonly type = AgreementTemplateActionTypes.AgreementTemplatesPageLoaded;
  constructor(public payload: { agreementTemplates: AgreementTemplate[]; totalCount: number }) {}
}

export class AgreementTemplatesPageCancelled implements Action {
  readonly type = AgreementTemplateActionTypes.AgreementTemplatesPageCancelled;
}

export class AllAgreementTemplatesRequested implements Action {
  readonly type = AgreementTemplateActionTypes.AllAgreementTemplatesRequested;
}

export class AllAgreementTemplatesLoaded implements Action {
  readonly type = AgreementTemplateActionTypes.AllAgreementTemplatesLoaded;
  constructor(public payload: { agreementTemplates: AgreementTemplate[] }) {}
}

export class AgreementTemplatesPageToggleLoading implements Action {
  readonly type = AgreementTemplateActionTypes.AgreementTemplatesPageToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class AgreementTemplatesActionToggleLoading implements Action {
  readonly type = AgreementTemplateActionTypes.AgreementTemplatesActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class ThrowAgreementTemplateError implements Action {
  readonly type = AgreementTemplateActionTypes.ThrowAgreementTemplateError;

  constructor(public payload: { error: any }) {}
}

export class FireAgreementTemplateSuccess implements Action {
  readonly type = AgreementTemplateActionTypes.FireAgreementTemplateSuccess;
  constructor(public payload: { action_type: string }) {}
}

export type AgreementTemplateActions =
  | AgreementTemplateCreated
  | AgreementTemplateUpdated
  | AgreementTemplateDeleted
  | AgreementTemplateActivated
  | AgreementTemplatesDeleted
  | AgreementTemplatesPageRequested
  | AgreementTemplatesPageLoaded
  | AgreementTemplatesPageCancelled
  | AllAgreementTemplatesLoaded
  | AllAgreementTemplatesRequested
  | AgreementTemplateOnServerCreated
  | AgreementTemplateOnServerUpdated
  | AgreementTemplateOnServerDeleted
  | AgreementTemplateOnServerActivated
  | AgreementTemplatesOnServerDeleted
  | AgreementTemplatesPageToggleLoading
  | AgreementTemplatesActionToggleLoading
  | ThrowAgreementTemplateError
  | FireAgreementTemplateSuccess;
